import { TRuleConfig } from "../../types/TRuleConfig";


export class RulesConfig {
	private readonly rulesConfig: Map<string, TRuleConfig>;

	public constructor(data: {[key: string]: {[key: string]: string | number | boolean}}) {
		const config: Map<string, TRuleConfig> = new Map<string, TRuleConfig>();

		Object.keys(data).forEach(key => {
			const deviceRulesData = data[key];
			const deviceRulesItem: TRuleConfig = {
				title: deviceRulesData.title as string || "",
				minValue: deviceRulesData.minValue as number,
				maxValue: deviceRulesData.maxValue as number,
				measure: deviceRulesData.measure as string,
				singleValue: deviceRulesData.singleValue as boolean || false,
				defaultValue: deviceRulesData.defaultValue,
			};

			config.set(key, deviceRulesItem);
		});

		this.rulesConfig = config;
	}

	public getRulesConfig(): Map<string, TRuleConfig> {
		return this.rulesConfig;
	}
}
